/**
 * Resets the document title to the default "Trellis"
 */
export const resetDocumentTitle = () => {
  const documentTitle = document.head.querySelector("title");
  if (documentTitle) {
    documentTitle.innerText = "Trellis";
  }
};
